import { Injectable } from '@angular/core';
import { ApiService, GetRequestArguments, PostRequestArguments, Refresh } from './api.service';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  public $addresses = new BehaviorSubject(<any>[]);
  public $editing = new BehaviorSubject(undefined);

  private url = 'address';
  private groupKey = 'address';
  constructor(private api: ApiService,
              private formBuilder: UntypedFormBuilder) {
  }

  public load(refresh: Refresh = 'expired', id = 'all') {
    if (!id) {
      id = 'all';
    }
    const args = new GetRequestArguments({
      url: [this.url, id],
      cacheGroup: this.groupKey,
      refresh,
    });
    const request = this.api.cachedGetRequest(args);
    request.subscribe(addresses => {
      this.api.updateObservable(addresses, this.$addresses);
    });
    return request;
  }

  public post(address) {
    const args = new PostRequestArguments({
      url: [this.url],
      object: address
    });
    const call = this.api.postRequest(args);
    return call;
  }

  delete(id) {
    const args = new PostRequestArguments({
      url: [this.url, id],
      object: id
    });

    const request = this.api.deleteRequest(args);
    return request;
  }

  public fillForm(address, form) {
    form.controls.id.patchValue(address.id);
    form.controls.street.patchValue(address.street);
    form.controls.number.patchValue(address.number);
    form.controls.city.patchValue(address.city);
    form.controls.country.patchValue(address.country);
    form.controls.zip_code.patchValue(address.zip_code);
  }

  public createForm() {
    return this.formBuilder.group({
      id: [undefined, []],
      street: [undefined, [Validators.required]],
      number: [undefined, [Validators.required]],
      city: [undefined, [Validators.required]],
      country: [undefined, [Validators.required]],
      zip_code: [undefined, [Validators.required]],
    });
  }
  
  createFormData(form) {
    return this.api.createFormData(form.value);
  }
}
